import { GooglePublisherTag } from '@components/google-publisher-tag';
import React, { type Dispatch, type FC, type SetStateAction } from 'react';
import Styles from '../../styles.scss';

export interface Props {
	setIsAdEmpty: Dispatch<SetStateAction<boolean | null>>;
	targeting: GooglePublisherTagTKWW.Targeting;
	isAdEmpty: boolean | null;
}

const SpotlightPromotion: FC<Props> = (props: Props) => {
	const { setIsAdEmpty, targeting, isAdEmpty } = props;

	return (
		<>
			<span className={Styles.spotlightPromotionLabel}>Promotion</span>
			<div
				className={
					isAdEmpty ? Styles.emptySpotlightContainer : Styles.spotlightContainer
				}
			>
				<GooglePublisherTag
					id="spotlight-ad"
					setIsAdEmpty={setIsAdEmpty}
					isAdEmpty={isAdEmpty}
					size={[943, 76]}
					targeting={targeting}
					destroyAdOnCleanup={true}
				/>
			</div>
		</>
	);
};

export default SpotlightPromotion;
